<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  <nb-option [value]="BuildingAttic.ConvertedAttic">Ausgebaut</nb-option>
  <nb-option [value]="BuildingAttic.NoConvertedAttic">Nicht ausgebaut</nb-option>
  <nb-option [value]="BuildingAttic.Partially">Teilweise ausgebaut</nb-option>
</nb-select>
